
import { HttpClient } from '@angular/common/http';
import { Injectable, Renderer2, signal } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../environments/environment';

// Enum which contains only LIGHT and DARK themes, if DEVICE theme selected it means you don't need a value for this purpose. DEVICE theme means no user preferences in the app. That is why value should be undefined (removed from localStorage).
export enum AppTheme {
  LIGHT = 'light',
  DARK = 'dark',
}
// for SSR and SSG support.
const CLIENT_RENDER = typeof localStorage !== 'undefined';
// name of variable in localStorage.
const LS_THEME = 'theme';
// previously selected value by user, if available.
let selectedTheme: AppTheme | undefined = undefined;
// if render happens on client side
if (CLIENT_RENDER) {
  // then set value from localStorage or if it not available leave it undefined.
  selectedTheme = localStorage.getItem(LS_THEME) as AppTheme || undefined;
}


@Injectable({
  providedIn: 'root'
})


export class ThemeService {
  url = environment.apiUrl;
  currentTheme = signal<AppTheme | undefined>(selectedTheme);
  currentRoute = signal<string | undefined>('');
  isDarkEnable!: boolean;
  isShowingNotifcations !: boolean
  changeTheme: Subject<boolean> = new Subject<boolean>();
  changeTitle: Subject<string> = new Subject<string>();
  showNotification: Subject<boolean> = new Subject<boolean>();
  constructor(private http: HttpClient) {
    this.loadTheme();

    this.changeTheme.subscribe((value) => {
      this.isDarkEnable = value
    });

    this.showNotification.subscribe((value)=>{
      this.isShowingNotifcations=value
    })
  }

  loadTheme(): void {
    const theme = localStorage.getItem(LS_THEME) || 'light';
    if (theme == AppTheme.LIGHT){
      this.setLightTheme();
    } else {
      this.setDarkTheme();
    }
  }


  setLightTheme() {
    this.currentTheme.set(AppTheme.LIGHT);
    this.setToLocalStorage(AppTheme.LIGHT);
    this.removeClassFromHtml('dark');
    this.changeTheme.next(false)
  }

  setTitle(title:string) {
   
    this.changeTitle.next(title)
  }
  setDarkTheme() {
    this.currentTheme.set(AppTheme.DARK);
    this.setToLocalStorage(AppTheme.DARK);
    this.addClassToHtml('dark');
    this.changeTheme.next(true)
  }
  setSystemTheme() {
    this.currentTheme.set(undefined);
    this.removeFromLocalStorage();
    if (isSystemDark()) {
      this.addClassToHtml('dark');
    } else {
      this.removeClassFromHtml('dark');
    }
  }
  private addClassToHtml(className: string) {
    if (CLIENT_RENDER) {
      this.removeClassFromHtml(className);
      document.documentElement.classList.add(className)
    }
  }
  private removeClassFromHtml(className: string) {
    if (CLIENT_RENDER) {
      document.documentElement.classList.remove(className)
    }
  }
  private setToLocalStorage(theme: AppTheme) {
    if (CLIENT_RENDER) {
      localStorage.setItem(LS_THEME, theme);
    }
  }
  private removeFromLocalStorage() {
    if (CLIENT_RENDER) {
      localStorage.removeItem(LS_THEME);
    }
  }


  getUserPreference(userId: number, clientNumber: number): Observable<any> {
    let queryParams = "clientNumber=" + clientNumber;
    if (userId > 0) {
      queryParams += "&userId?=" + userId
    }
    return this.http.get(this.url + 'user/preferences?' + queryParams);
  }
}
function isSystemDark() {
  if (typeof window !== 'undefined') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  } else {
    return false;
  }
}